import { useUpdateAppointmentProviderMutation } from "../../../../../../../api/appointments/useUpdateAppointmentProviderMutation";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../../utilities/api";
import { useContext } from "../context";

export function useUpdateProvider() {
  const { tCommon: t } = useAppTranslation.Common();
  const { appointment } = useContext();

  const { mutateAsync, isLoading } = useUpdateAppointmentProviderMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(
        t(
          `event.apiError.${message}`,
          "Unable to update provider. Try again later.",
        ),
      );
    },
    onSuccess: () => {
      uiNotification.success("Provider updated successfully.");
    },
  });

  return {
    initiate: ({ providerId }) => {
      return mutateAsync({
        appointmentId: appointment.id,
        providerId: Number(providerId),
      });
    },
    isLoading,
  };
}
